var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,3v8H11V0H3A3,3,0,0,0,0,3ZM3,3H8V8H3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21,0H13V11H24V3A3,3,0,0,0,21,0Zm0,8H16V3h5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,21a3,3,0,0,0,3,3h8V13H0Zm3-5H8v5H3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13,24h8a3,3,0,0,0,3-3V13H13Zm3-8h5v5H16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.fbbebb0c1ae5f9899188d4514e23b8ac.svg";
export { ForwardRef as ReactComponent };